import React, { Component } from 'react'
import './Showcase.module.scss'
// import placeholder from './placeholder.jpg'

class Showcase extends Component {
  render () {
    return (
      <div styleName='wrap'>
        {/* <div styleName='media'>
          <img src={placeholder} />
        </div> */}
        <h1 styleName='title'>
          Nik Sytnik
          <span>(b. 1990 UKR)</span>
        </h1>
      </div>
    )
  }
}

export default Showcase



// WEBPACK FOOTER //
// ./src/components/Showcase/index.js